// Onboarding page /logos-setup (DEV_TECH_DESIGN-0030 §5.1). Platform-gated
// install flow with a live detection panel that auto-polls the local bridge.
import { getPlatform } from './platform.js';
import { probeHealth } from './bridge_client.js';

const POLL_INTERVAL_MS = 2500;
// After the antivirus-help state is reached, keep polling at a slower cadence.
const SLOW_POLL_INTERVAL_MS = 10000;
// "Silent failure" heuristic: no bridge this long after the download click.
const AV_HELP_AFTER_MS = 60000;
// sessionStorage key for the download-click timestamp (t0, §5.1).
const DOWNLOAD_T0_KEY = 'shepwiseBridgeDownloadT0';

const DETECTION_STATES = [
    'detectionSearching',
    'detectionSuccess',
    'detectionNoLogos',
    'detectionAvHelp'
];

function showDetectionState(activeId) {
    DETECTION_STATES.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.classList.toggle('d-none', id !== activeId);
    });
}

function downloadT0() {
    const raw = sessionStorage.getItem(DOWNLOAD_T0_KEY);
    return raw ? parseInt(raw, 10) : null;
}

function nextDetectionState(health) {
    if (health && health.logos_data_found) return 'detectionSuccess';
    if (health) return 'detectionNoLogos';
    // A visitor who never clicked download (no t0) must not see the
    // antivirus notice — keep the neutral searching state.
    const t0 = downloadT0();
    if (t0 && Date.now() - t0 > AV_HELP_AFTER_MS) return 'detectionAvHelp';
    return 'detectionSearching';
}

async function pollLoop() {
    const health = await probeHealth();
    const state = nextDetectionState(health);
    showDetectionState(state);
    if (state === 'detectionSuccess') return; // done — stop polling
    const interval = state === 'detectionAvHelp' ? SLOW_POLL_INTERVAL_MS : POLL_INTERVAL_MS;
    setTimeout(pollLoop, interval);
}

function initWindowsFlow() {
    document.getElementById('setupWindowsFlow').classList.remove('d-none');
    const downloadBtn = document.getElementById('bridgeDownloadBtn');
    downloadBtn.addEventListener('click', () => {
        sessionStorage.setItem(DOWNLOAD_T0_KEY, String(Date.now()));
    });
    pollLoop();
}

export function initializeLogosSetupPage() {
    const noticeByPlatform = {
        macos: 'setupMacNotice',
        mobile: 'setupMobileNotice',
        other: 'setupOtherNotice'
    };
    const platform = getPlatform();
    if (platform === 'windows') {
        initWindowsFlow();
        return;
    }
    document.getElementById(noticeByPlatform[platform]).classList.remove('d-none');
}
